function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
import useAxios from "./use-axios";
var useRewardTags = function useRewardTags(_ref) {
  var categoryId = _ref.categoryId,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    tags = _useState2[0],
    setTags = _useState2[1];
  var isAuthenticated = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    isLoading = _useAxios.isLoading,
    error = _useAxios.error,
    fetchTags = _useAxios.sendRequest;
  var getTags = function getTags() {
    if (!categoryId) {
      setTags([]);
      return;
    }
    fetchTags({
      isEncryptedResponse: true,
      url: isAuthenticated ? "/winnre/user/tags/getAllByType?types=REWARD&pageSize=50&rewardCategoryIds=".concat(categoryId, "&rewardsPage=true") : "/winnre/no-auth/tags/getAllByType?types=REWARD&pageSize=50&rewardCategoryIds=".concat(categoryId, "&rewardsPage=true"),
      method: "get"
    }, function (data) {
      console.log("Tags for reward category ".concat(categoryId, ":"), data);
      setTags(data.content || []);
    });
  };
  useEffect(function () {
    getTags();
  }, [categoryId, isAuthenticated]);
  return {
    isLoading: isLoading,
    error: error,
    tags: tags,
    refetchTags: getTags
  };
};
export default useRewardTags;